// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { TrusteeDropdown_HouseholdFragment } from '../../inputs/TrusteeDropdown/graphql/TrusteeDropdown.generated';
import { PrimaryClientDropdown_HouseholdWithGrantorsFragment } from '../../inputs/PrimaryClientDropdown/graphql/PrimaryClientDropdown.generated';
import { gql } from '@apollo/client';
import { TrusteeDropdown_HouseholdFragmentDoc } from '../../inputs/TrusteeDropdown/graphql/TrusteeDropdown.generated';
import { PrimaryClientDropdown_HouseholdWithGrantorsFragmentDoc } from '../../inputs/PrimaryClientDropdown/graphql/PrimaryClientDropdown.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TrustDetailsSubformTrustAdvisorFragment = { __typename?: 'TrustAdvisor', id: string, level: Types.TrustAdvisorLevel, note?: string | null, individual?: { __typename?: 'ClientProfile', id: string, displayName: string } | null, organization?: { __typename?: 'ClientOrganization', id: string, name: string } | null, roles?: Array<{ __typename?: 'TrustAdvisorRole', id: string, kind: Types.TrustAdvisorRoleKind }> | null };

export type TrustDetailsSubformTrusteeFragment = { __typename?: 'Trustee', id: string, level?: Types.TrusteeLevel | null, notes?: string | null, duties?: Array<{ __typename?: 'TrusteeDuty', id: string, kind: Types.TrusteeDutyKind }> | null, individual?: { __typename?: 'ClientProfile', displayName: string, id: string } | null, organization?: { __typename?: 'ClientOrganization', id: string, name: string } | null };

export type IrrevocableTrustTrustDetailsFragment = { __typename?: 'IrrevocableTrust', id: string, trustAdvisors?: Array<(
    { __typename?: 'TrustAdvisor' }
    & TrustDetailsSubformTrustAdvisorFragment
  )> | null, successorTrustees?: Array<(
    { __typename?: 'Trustee' }
    & TrustDetailsSubformTrusteeFragment
  )> | null, trustees?: Array<(
    { __typename?: 'Trustee' }
    & TrustDetailsSubformTrusteeFragment
  )> | null };

export type RevocableTrustTrustDetailsFragment = { __typename?: 'RevocableTrust', id: string, trustAdvisors?: Array<(
    { __typename?: 'TrustAdvisor' }
    & TrustDetailsSubformTrustAdvisorFragment
  )> | null, successorTrustees?: Array<(
    { __typename?: 'Trustee' }
    & TrustDetailsSubformTrusteeFragment
  )> | null, trustees?: Array<(
    { __typename?: 'Trustee' }
    & TrustDetailsSubformTrusteeFragment
  )> | null };

export type SlatTrustTrustDetailsFragment = { __typename?: 'SLATTrust', id: string, trustAdvisors?: Array<(
    { __typename?: 'TrustAdvisor' }
    & TrustDetailsSubformTrustAdvisorFragment
  )> | null, successorTrustees?: Array<(
    { __typename?: 'Trustee' }
    & TrustDetailsSubformTrusteeFragment
  )> | null, trustees?: Array<(
    { __typename?: 'Trustee' }
    & TrustDetailsSubformTrusteeFragment
  )> | null };

export type GratTrustTrustDetailsFragment = { __typename?: 'GRATTrust', id: string, trustAdvisors?: Array<(
    { __typename?: 'TrustAdvisor' }
    & TrustDetailsSubformTrustAdvisorFragment
  )> | null, successorTrustees?: Array<(
    { __typename?: 'Trustee' }
    & TrustDetailsSubformTrusteeFragment
  )> | null, trustees?: Array<(
    { __typename?: 'Trustee' }
    & TrustDetailsSubformTrusteeFragment
  )> | null };

export type IlitTrustTrustDetailsFragment = { __typename?: 'ILITTrust', id: string, trustAdvisors?: Array<(
    { __typename?: 'TrustAdvisor' }
    & TrustDetailsSubformTrustAdvisorFragment
  )> | null, successorTrustees?: Array<(
    { __typename?: 'Trustee' }
    & TrustDetailsSubformTrusteeFragment
  )> | null, trustees?: Array<(
    { __typename?: 'Trustee' }
    & TrustDetailsSubformTrusteeFragment
  )> | null };

export type QprtTrustTrustDetailsFragment = { __typename?: 'QPRTTrust', id: string, trustAdvisors?: Array<(
    { __typename?: 'TrustAdvisor' }
    & TrustDetailsSubformTrustAdvisorFragment
  )> | null, successorTrustees?: Array<(
    { __typename?: 'Trustee' }
    & TrustDetailsSubformTrusteeFragment
  )> | null, trustees?: Array<(
    { __typename?: 'Trustee' }
    & TrustDetailsSubformTrusteeFragment
  )> | null };

export type CltTrustTrustDetailsFragment = { __typename?: 'CLTTrust', id: string, trustAdvisors?: Array<(
    { __typename?: 'TrustAdvisor' }
    & TrustDetailsSubformTrustAdvisorFragment
  )> | null, successorTrustees?: Array<(
    { __typename?: 'Trustee' }
    & TrustDetailsSubformTrusteeFragment
  )> | null, trustees?: Array<(
    { __typename?: 'Trustee' }
    & TrustDetailsSubformTrusteeFragment
  )> | null };

export type CrtTrustTrustDetailsFragment = { __typename?: 'CRTTrust', id: string, trustAdvisors?: Array<(
    { __typename?: 'TrustAdvisor' }
    & TrustDetailsSubformTrustAdvisorFragment
  )> | null, successorTrustees?: Array<(
    { __typename?: 'Trustee' }
    & TrustDetailsSubformTrusteeFragment
  )> | null, trustees?: Array<(
    { __typename?: 'Trustee' }
    & TrustDetailsSubformTrusteeFragment
  )> | null };

export type TrustDetailsQueryVariables = Types.Exact<{
  nodeId: Types.Scalars['ID']['input'];
}>;


export type TrustDetailsQuery = { __typename?: 'Query', node?: { __typename?: 'AISuggestion' } | { __typename?: 'AISuggestionEvidence' } | { __typename?: 'AccessAgeParameter' } | { __typename?: 'AccessParameter' } | { __typename?: 'Account' } | { __typename?: 'ActiveEstateInsightsPage' } | { __typename?: 'Activity' } | { __typename?: 'Address' } | { __typename?: 'Answer' } | { __typename?: 'AnswerEvidence' } | { __typename?: 'AnswerRevision' } | { __typename?: 'Approval' } | { __typename?: 'AssetClass' } | { __typename?: 'AssetGroup' } | { __typename?: 'AssetStatic' } | { __typename?: 'AssetV2' } | { __typename?: 'AssetValuationV2' } | { __typename?: 'AssetValueV2' } | { __typename?: 'AsyncJob' } | { __typename?: 'BalanceSheetBundleConfiguration' } | { __typename?: 'BalanceSheetCategory' } | { __typename?: 'BalanceSheetViewConfiguration' } | { __typename?: 'BeneficiariesBundleConfiguration' } | { __typename?: 'BeneficiariesTemplateBundleConfiguration' } | { __typename?: 'Beneficiary' } | { __typename?: 'BeneficiaryAccessParameter' } | { __typename?: 'BeneficiaryDesignationGroup' } | { __typename?: 'BeneficiaryDistribution' } | { __typename?: 'BeneficiaryDistributionParameter' } | { __typename?: 'BeneficiaryPage' } | { __typename?: 'BeneficiaryPowerOfAppointment' } | { __typename?: 'CCorpBusinessEntity' } | { __typename?: 'CLTProposal' } | { __typename?: 'CLTTrust' } | { __typename?: 'CRTProposal' } | { __typename?: 'CRTTrust' } | { __typename?: 'Capability' } | { __typename?: 'Cashflow' } | { __typename?: 'ClientOrganization' } | { __typename?: 'ClientPresentationV2' } | { __typename?: 'ClientProfile' } | { __typename?: 'ClientProfileRelationship' } | { __typename?: 'Collaborator' } | { __typename?: 'ComparedWaterfall' } | { __typename?: 'CompletedEstateInsightsPage' } | { __typename?: 'ControllingParty' } | { __typename?: 'Conversation' } | { __typename?: 'CoverPageConfiguration' } | { __typename?: 'CustodialPersonalAccount' } | { __typename?: 'DSUEPortability' } | { __typename?: 'DiagramArtifact' } | { __typename?: 'DiagramArtifactPrompt' } | { __typename?: 'DispositionScenario' } | { __typename?: 'DispositiveProvision' } | { __typename?: 'DispositiveProvisionTemplate' } | { __typename?: 'DividerBundleConfiguration' } | { __typename?: 'DividerTemplateBundleConfiguration' } | { __typename?: 'Document' } | { __typename?: 'DocumentQuestion' } | { __typename?: 'DocumentQuestionAnswers' } | { __typename?: 'DocumentSummary' } | { __typename?: 'DocumentSummaryPage' } | { __typename?: 'DocumentSummaryPrompt' } | { __typename?: 'DocumentSummaryPromptTestRun' } | { __typename?: 'DocumentSummaryTemplateBundleConfiguration' } | { __typename?: 'DonorAdvisedFund' } | { __typename?: 'Employee' } | { __typename?: 'EntitiesOverviewBundleConfiguration' } | { __typename?: 'EntitiesOverviewBundleConfigurationEntity' } | { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity' } | (
      { __typename?: 'CLTTrust' }
      & CltTrustTrustDetailsFragment
    ) | (
      { __typename?: 'CRTTrust' }
      & CrtTrustTrustDetailsFragment
    ) | { __typename?: 'CustodialPersonalAccount' } | { __typename?: 'DonorAdvisedFund' } | { __typename?: 'GPBusinessEntity' } | (
      { __typename?: 'GRATTrust' }
      & GratTrustTrustDetailsFragment
    ) | (
      { __typename?: 'ILITTrust' }
      & IlitTrustTrustDetailsFragment
    ) | { __typename?: 'IndividualPersonalAccount' } | { __typename?: 'InsurancePersonalAccount' } | (
      { __typename?: 'IrrevocableTrust' }
      & IrrevocableTrustTrustDetailsFragment
    ) | { __typename?: 'JointPersonalAccount' } | { __typename?: 'LLCBusinessEntity' } | { __typename?: 'LPBusinessEntity' } | { __typename?: 'PrivateFoundation' } | (
      { __typename?: 'QPRTTrust' }
      & QprtTrustTrustDetailsFragment
    ) | { __typename?: 'QualifiedTuitionPersonalAccount' } | { __typename?: 'RetirementPersonalAccount' } | (
      { __typename?: 'RevocableTrust' }
      & RevocableTrustTrustDetailsFragment
    ) | { __typename?: 'SCorpBusinessEntity' } | (
      { __typename?: 'SLATTrust' }
      & SlatTrustTrustDetailsFragment
    ) | { __typename?: 'SoleProprietorshipBusinessEntity' } } | { __typename?: 'EntityDiagram' } | { __typename?: 'EntityDocumentRelationship' } | { __typename?: 'EntityGraphView' } | { __typename?: 'EntityGraphViewBundleConfiguration' } | { __typename?: 'EntityNotes' } | { __typename?: 'EntityProposal' } | { __typename?: 'EntitySummaryBundleConfiguration' } | { __typename?: 'EntitySummaryTemplateBundleConfiguration' } | { __typename?: 'EntityTask' } | { __typename?: 'EntityTaxInfo' } | { __typename?: 'EstateInsight' } | { __typename?: 'EstateInsightReference' } | { __typename?: 'EstateInsightsBundleConfiguration' } | { __typename?: 'EstateTaxScenario' } | { __typename?: 'EstateWaterfall' } | { __typename?: 'EstateWaterfallHypotheticalStateChange' } | { __typename?: 'EstateWaterfallHypotheticalTransfer' } | { __typename?: 'EstateWaterfallMessageContext' } | { __typename?: 'EstateWaterfallVisualizationConfig' } | { __typename?: 'EstateWaterfallVisualizationFilter' } | { __typename?: 'FamilyTreeBundleConfiguration' } | { __typename?: 'FamilyTreeConfiguration' } | { __typename?: 'FeatureFlag' } | { __typename?: 'FeatureFlagQueryRule' } | { __typename?: 'File' } | { __typename?: 'FilePage' } | { __typename?: 'FileParagraph' } | { __typename?: 'Form' } | { __typename?: 'FormVersion' } | { __typename?: 'GPBusinessEntity' } | { __typename?: 'GRATAnnuityV2' } | { __typename?: 'GRATProposalScenario' } | { __typename?: 'GRATTrust' } | { __typename?: 'GiftingProposal' } | { __typename?: 'GiftingProposalCashFlow' } | { __typename?: 'GiftingProposalGift' } | { __typename?: 'GiftingProposalGiftSender' } | { __typename?: 'GiftingProposalPortfolio' } | { __typename?: 'GiftingProposalScenario' } | { __typename?: 'GraphVisualizationGroup' } | { __typename?: 'GrowthProfile' } | { __typename?: 'GrowthProfileOverride' } | { __typename?: 'Household' } | { __typename?: 'HypotheticalCLT' } | { __typename?: 'HypotheticalCRT' } | { __typename?: 'HypotheticalGRAT' } | { __typename?: 'HypotheticalInsurance' } | { __typename?: 'HypotheticalSaleLoan' } | { __typename?: 'HypotheticalTransferAsset' } | { __typename?: 'HypotheticalTransferFundingSource' } | { __typename?: 'HypotheticalWaterfallDispositiveProvisionTemplate' } | { __typename?: 'ILITCrummeyLetter' } | { __typename?: 'ILITTrust' } | { __typename?: 'Image' } | { __typename?: 'IncomeTaxPaymentConfig' } | { __typename?: 'IndividualPersonalAccount' } | { __typename?: 'InferredField' } | { __typename?: 'InferredFieldEvidence' } | { __typename?: 'InsightsTemplateBundleConfiguration' } | { __typename?: 'InsurancePersonalAccount' } | { __typename?: 'InsurancePolicy' } | { __typename?: 'InsurancePremiumPayment' } | { __typename?: 'IntegrationAssetClass' } | { __typename?: 'IntegrationCashflow' } | { __typename?: 'IntegrationClient' } | { __typename?: 'IntegrationConfiguration' } | { __typename?: 'IntegrationEntity' } | { __typename?: 'IntegrationInsurance' } | { __typename?: 'IntegrationLiability' } | { __typename?: 'IntegrationPerson' } | { __typename?: 'IrrevocableTrust' } | { __typename?: 'JointPersonalAccount' } | { __typename?: 'KGNode' } | { __typename?: 'KGRelationship' } | { __typename?: 'KGRoot' } | { __typename?: 'KGV2Document' } | { __typename?: 'KGV2DocumentChange' } | { __typename?: 'KGV2DocumentModification' } | { __typename?: 'KGV2Graph' } | { __typename?: 'KGV2Node' } | { __typename?: 'KGV2NodeAlias' } | { __typename?: 'KGV2NodeEvidence' } | { __typename?: 'KGV2Statement' } | { __typename?: 'KGV2StatementEvidence' } | { __typename?: 'KGV2StatementSupersession' } | { __typename?: 'KeyPerson' } | { __typename?: 'KeyPersonRole' } | { __typename?: 'LLCBusinessEntity' } | { __typename?: 'LPBusinessEntity' } | { __typename?: 'LiabilitiesBundleConfiguration' } | { __typename?: 'Liability' } | { __typename?: 'LiabilityPayment' } | { __typename?: 'LifeInsuranceBundleConfiguration' } | { __typename?: 'LifetimeExclusionEvent' } | { __typename?: 'LoggedTransfer' } | { __typename?: 'LuminaryOrganization' } | { __typename?: 'LuminaryTenantJIT' } | { __typename?: 'ManagedSFTPConnection' } | { __typename?: 'Memo' } | { __typename?: 'MemoPrompt' } | { __typename?: 'Message' } | { __typename?: 'MissingDocumentOverride' } | { __typename?: 'MissingDocumentsPage' } | { __typename?: 'ModelMapping' } | { __typename?: 'NotificationApp' } | { __typename?: 'NotificationPreference' } | { __typename?: 'OpenaiSdkConfig' } | { __typename?: 'OrganizationApplicationConfiguration' } | { __typename?: 'OrganizationDisclaimerConfiguration' } | { __typename?: 'OwnershipStake' } | { __typename?: 'PlatformDocument' } | { __typename?: 'PlatformFile' } | { __typename?: 'PlatformFilePage' } | { __typename?: 'PlatformFileParagraph' } | { __typename?: 'PresentationApprovalRequest' } | { __typename?: 'PresentationAssetDistributionBundleConfiguration' } | { __typename?: 'PresentationAssetDistributionItemConfiguration' } | { __typename?: 'PresentationAssetDistributionItemDetail' } | { __typename?: 'PresentationBundle' } | { __typename?: 'PresentationBundleCoverPage' } | { __typename?: 'PresentationBusinessOverviewBundleConfiguration' } | { __typename?: 'PresentationBusinessOverviewBusinessConfiguration' } | { __typename?: 'PresentationBusinessOverviewItem' } | { __typename?: 'PresentationCoverPage' } | { __typename?: 'PresentationCoverSlideConfig' } | { __typename?: 'PresentationCustomPage' } | { __typename?: 'PresentationCustomPageBundleConfiguration' } | { __typename?: 'PresentationDiagramPage' } | { __typename?: 'PresentationDocumentsReviewedBundleConfiguration' } | { __typename?: 'PresentationDocumentsReviewedDocument' } | { __typename?: 'PresentationFamilyOverviewBundleConfiguration' } | { __typename?: 'PresentationFamilyOverviewMemberConfiguration' } | { __typename?: 'PresentationHealthcareDirectiveBundleConfiguration' } | { __typename?: 'PresentationHealthcareDirectiveClientConfiguration' } | { __typename?: 'PresentationHealthcareDirectiveItem' } | { __typename?: 'PresentationItemCitation' } | { __typename?: 'PresentationPage' } | { __typename?: 'PresentationPlanningOpportunitiesBundleConfiguration' } | { __typename?: 'PresentationPlanningOpportunitiesItem' } | { __typename?: 'PresentationPowerOfAttorneyBundleConfiguration' } | { __typename?: 'PresentationPowerOfAttorneyClientConfiguration' } | { __typename?: 'PresentationPowerOfAttorneyItem' } | { __typename?: 'PresentationTemplate' } | { __typename?: 'PresentationTemplateBundle' } | { __typename?: 'PresentationTemplateCoverPage' } | { __typename?: 'PresentationTemplateCustomPage' } | { __typename?: 'PresentationTemplateDiagramPage' } | { __typename?: 'PresentationTemplatePage' } | { __typename?: 'PresentationTrustOverviewBundleConfiguration' } | { __typename?: 'PresentationTrustOverviewItem' } | { __typename?: 'PresentationTrustOverviewTrustConfiguration' } | { __typename?: 'PresentationWillBundleConfiguration' } | { __typename?: 'PresentationWillClientConfiguration' } | { __typename?: 'PresentationWillItem' } | { __typename?: 'Principal' } | { __typename?: 'PrivateFoundation' } | { __typename?: 'ProfessionalTeamRole' } | { __typename?: 'Proposal' } | { __typename?: 'ProposalScenario' } | { __typename?: 'QPRTTrust' } | { __typename?: 'QualifiedTuitionPersonalAccount' } | { __typename?: 'ReleaseGroup' } | { __typename?: 'ReminderEmailNotificationRecord' } | { __typename?: 'RetirementPersonalAccount' } | { __typename?: 'RevocableTrust' } | { __typename?: 'Role' } | { __typename?: 'SCorpBusinessEntity' } | { __typename?: 'SLATTrust' } | { __typename?: 'SSOConnection' } | { __typename?: 'SalesforceExportAttempt' } | { __typename?: 'ScheduledDistribution' } | { __typename?: 'SoleProprietorshipBusinessEntity' } | { __typename?: 'SubBrand' } | { __typename?: 'SubBrandDisclaimerConfiguration' } | { __typename?: 'Submission' } | { __typename?: 'TaxDragConfig' } | { __typename?: 'TaxDragOverride' } | { __typename?: 'Team' } | { __typename?: 'Tenant' } | { __typename?: 'TenantApplicationConfiguration' } | { __typename?: 'TenantBranding' } | { __typename?: 'TenantDisclaimerConfiguration' } | { __typename?: 'TenantDocument' } | { __typename?: 'TenantReminderEmailsConfiguration' } | { __typename?: 'TenantSSOConnection' } | { __typename?: 'TenantSecurityConfiguration' } | { __typename?: 'TenantSlideConfig' } | { __typename?: 'TestCMKEncryption' } | { __typename?: 'TestamentaryEntity' } | { __typename?: 'TrustAdvisor' } | { __typename?: 'TrustAdvisorRole' } | { __typename?: 'Trustee' } | { __typename?: 'TrusteeDuty' } | { __typename?: 'User' } | { __typename?: 'UserFeedback' } | { __typename?: 'UserNotificationConfiguration' } | { __typename?: 'WaterfallBundleConfiguration' } | { __typename?: 'WaterfallBundleCoverPage' } | { __typename?: 'WaterfallComparisonBundleConfiguration' } | { __typename?: 'WaterfallComparisonTemplateBundleConfiguration' } | { __typename?: 'WaterfallTemplateBundleConfiguration' } | { __typename?: 'WorkOSOrganization' } | { __typename?: 'WorkOSOrganizationDomain' } | { __typename?: 'WorkflowTracker' } | null };

export type TrustDetailsFormOptionsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.HouseholdWhereInput>;
}>;


export type TrustDetailsFormOptionsQuery = { __typename?: 'Query', households: { __typename?: 'HouseholdConnection', edges?: Array<{ __typename?: 'HouseholdEdge', node?: (
        { __typename?: 'Household' }
        & TrusteeDropdown_HouseholdFragment
        & PrimaryClientDropdown_HouseholdWithGrantorsFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    TrustDetails: 'TrustDetails' as const,
    TrustDetailsFormOptions: 'TrustDetailsFormOptions' as const
  },
  Fragment: {
    TrustDetailsSubformTrustAdvisor: 'TrustDetailsSubformTrustAdvisor' as const,
    TrustDetailsSubformTrustee: 'TrustDetailsSubformTrustee' as const,
    IrrevocableTrustTrustDetails: 'IrrevocableTrustTrustDetails' as const,
    RevocableTrustTrustDetails: 'RevocableTrustTrustDetails' as const,
    SLATTrustTrustDetails: 'SLATTrustTrustDetails' as const,
    GRATTrustTrustDetails: 'GRATTrustTrustDetails' as const,
    ILITTrustTrustDetails: 'ILITTrustTrustDetails' as const,
    QPRTTrustTrustDetails: 'QPRTTrustTrustDetails' as const,
    CLTTrustTrustDetails: 'CLTTrustTrustDetails' as const,
    CRTTrustTrustDetails: 'CRTTrustTrustDetails' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const TrustDetailsSubformTrustAdvisorFragmentDoc = gql`
    fragment TrustDetailsSubformTrustAdvisor on TrustAdvisor {
  id
  level
  note
  individual {
    id
    displayName
  }
  organization {
    id
    name
  }
  roles {
    id
    kind
  }
}
    `;
export const TrustDetailsSubformTrusteeFragmentDoc = gql`
    fragment TrustDetailsSubformTrustee on Trustee {
  id
  level
  notes
  duties {
    id
    kind
  }
  individual {
    displayName
    id
  }
  organization {
    id
    name
  }
}
    `;
export const IrrevocableTrustTrustDetailsFragmentDoc = gql`
    fragment IrrevocableTrustTrustDetails on IrrevocableTrust {
  id
  trustAdvisors {
    ...TrustDetailsSubformTrustAdvisor
  }
  successorTrustees {
    ...TrustDetailsSubformTrustee
  }
  trustees {
    ...TrustDetailsSubformTrustee
  }
}
    ${TrustDetailsSubformTrustAdvisorFragmentDoc}
${TrustDetailsSubformTrusteeFragmentDoc}`;
export const RevocableTrustTrustDetailsFragmentDoc = gql`
    fragment RevocableTrustTrustDetails on RevocableTrust {
  id
  trustAdvisors {
    ...TrustDetailsSubformTrustAdvisor
  }
  successorTrustees {
    ...TrustDetailsSubformTrustee
  }
  trustees {
    ...TrustDetailsSubformTrustee
  }
}
    ${TrustDetailsSubformTrustAdvisorFragmentDoc}
${TrustDetailsSubformTrusteeFragmentDoc}`;
export const SlatTrustTrustDetailsFragmentDoc = gql`
    fragment SLATTrustTrustDetails on SLATTrust {
  id
  trustAdvisors {
    ...TrustDetailsSubformTrustAdvisor
  }
  successorTrustees {
    ...TrustDetailsSubformTrustee
  }
  trustees {
    ...TrustDetailsSubformTrustee
  }
}
    ${TrustDetailsSubformTrustAdvisorFragmentDoc}
${TrustDetailsSubformTrusteeFragmentDoc}`;
export const GratTrustTrustDetailsFragmentDoc = gql`
    fragment GRATTrustTrustDetails on GRATTrust {
  id
  trustAdvisors {
    ...TrustDetailsSubformTrustAdvisor
  }
  successorTrustees {
    ...TrustDetailsSubformTrustee
  }
  trustees {
    ...TrustDetailsSubformTrustee
  }
}
    ${TrustDetailsSubformTrustAdvisorFragmentDoc}
${TrustDetailsSubformTrusteeFragmentDoc}`;
export const IlitTrustTrustDetailsFragmentDoc = gql`
    fragment ILITTrustTrustDetails on ILITTrust {
  id
  trustAdvisors {
    ...TrustDetailsSubformTrustAdvisor
  }
  successorTrustees {
    ...TrustDetailsSubformTrustee
  }
  trustees {
    ...TrustDetailsSubformTrustee
  }
}
    ${TrustDetailsSubformTrustAdvisorFragmentDoc}
${TrustDetailsSubformTrusteeFragmentDoc}`;
export const QprtTrustTrustDetailsFragmentDoc = gql`
    fragment QPRTTrustTrustDetails on QPRTTrust {
  id
  trustAdvisors {
    ...TrustDetailsSubformTrustAdvisor
  }
  successorTrustees {
    ...TrustDetailsSubformTrustee
  }
  trustees {
    ...TrustDetailsSubformTrustee
  }
}
    ${TrustDetailsSubformTrustAdvisorFragmentDoc}
${TrustDetailsSubformTrusteeFragmentDoc}`;
export const CltTrustTrustDetailsFragmentDoc = gql`
    fragment CLTTrustTrustDetails on CLTTrust {
  id
  trustAdvisors {
    ...TrustDetailsSubformTrustAdvisor
  }
  successorTrustees {
    ...TrustDetailsSubformTrustee
  }
  trustees {
    ...TrustDetailsSubformTrustee
  }
}
    ${TrustDetailsSubformTrustAdvisorFragmentDoc}
${TrustDetailsSubformTrusteeFragmentDoc}`;
export const CrtTrustTrustDetailsFragmentDoc = gql`
    fragment CRTTrustTrustDetails on CRTTrust {
  id
  trustAdvisors {
    ...TrustDetailsSubformTrustAdvisor
  }
  successorTrustees {
    ...TrustDetailsSubformTrustee
  }
  trustees {
    ...TrustDetailsSubformTrustee
  }
}
    ${TrustDetailsSubformTrustAdvisorFragmentDoc}
${TrustDetailsSubformTrusteeFragmentDoc}`;
export const TrustDetailsDocument = gql`
    query TrustDetails($nodeId: ID!) {
  node(id: $nodeId) {
    ... on Entity {
      id
      subtype {
        ...IrrevocableTrustTrustDetails
        ...RevocableTrustTrustDetails
        ...GRATTrustTrustDetails
        ...SLATTrustTrustDetails
        ...ILITTrustTrustDetails
        ...QPRTTrustTrustDetails
        ...CLTTrustTrustDetails
        ...CRTTrustTrustDetails
      }
    }
  }
}
    ${IrrevocableTrustTrustDetailsFragmentDoc}
${RevocableTrustTrustDetailsFragmentDoc}
${GratTrustTrustDetailsFragmentDoc}
${SlatTrustTrustDetailsFragmentDoc}
${IlitTrustTrustDetailsFragmentDoc}
${QprtTrustTrustDetailsFragmentDoc}
${CltTrustTrustDetailsFragmentDoc}
${CrtTrustTrustDetailsFragmentDoc}`;

/**
 * __useTrustDetailsQuery__
 *
 * To run a query within a React component, call `useTrustDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrustDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrustDetailsQuery({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useTrustDetailsQuery(baseOptions: Apollo.QueryHookOptions<TrustDetailsQuery, TrustDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrustDetailsQuery, TrustDetailsQueryVariables>(TrustDetailsDocument, withFetchPolicyContext(options));
      }
export function useTrustDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrustDetailsQuery, TrustDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrustDetailsQuery, TrustDetailsQueryVariables>(TrustDetailsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useTrustDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrustDetailsQuery, TrustDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrustDetailsQuery, TrustDetailsQueryVariables>(TrustDetailsDocument, withFetchPolicyContext(options));
        }
export type TrustDetailsQueryHookResult = ReturnType<typeof useTrustDetailsQuery>;
export type TrustDetailsLazyQueryHookResult = ReturnType<typeof useTrustDetailsLazyQuery>;
export type TrustDetailsSuspenseQueryHookResult = ReturnType<typeof useTrustDetailsSuspenseQuery>;
export type TrustDetailsQueryResult = Apollo.QueryResult<TrustDetailsQuery, TrustDetailsQueryVariables>;
export const TrustDetailsFormOptionsDocument = gql`
    query TrustDetailsFormOptions($where: HouseholdWhereInput) {
  households(where: $where) {
    edges {
      node {
        ...TrusteeDropdown_Household
        ...PrimaryClientDropdown_HouseholdWithGrantors
      }
    }
  }
}
    ${TrusteeDropdown_HouseholdFragmentDoc}
${PrimaryClientDropdown_HouseholdWithGrantorsFragmentDoc}`;

/**
 * __useTrustDetailsFormOptionsQuery__
 *
 * To run a query within a React component, call `useTrustDetailsFormOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrustDetailsFormOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrustDetailsFormOptionsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useTrustDetailsFormOptionsQuery(baseOptions?: Apollo.QueryHookOptions<TrustDetailsFormOptionsQuery, TrustDetailsFormOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrustDetailsFormOptionsQuery, TrustDetailsFormOptionsQueryVariables>(TrustDetailsFormOptionsDocument, withFetchPolicyContext(options));
      }
export function useTrustDetailsFormOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrustDetailsFormOptionsQuery, TrustDetailsFormOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrustDetailsFormOptionsQuery, TrustDetailsFormOptionsQueryVariables>(TrustDetailsFormOptionsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useTrustDetailsFormOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TrustDetailsFormOptionsQuery, TrustDetailsFormOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrustDetailsFormOptionsQuery, TrustDetailsFormOptionsQueryVariables>(TrustDetailsFormOptionsDocument, withFetchPolicyContext(options));
        }
export type TrustDetailsFormOptionsQueryHookResult = ReturnType<typeof useTrustDetailsFormOptionsQuery>;
export type TrustDetailsFormOptionsLazyQueryHookResult = ReturnType<typeof useTrustDetailsFormOptionsLazyQuery>;
export type TrustDetailsFormOptionsSuspenseQueryHookResult = ReturnType<typeof useTrustDetailsFormOptionsSuspenseQuery>;
export type TrustDetailsFormOptionsQueryResult = Apollo.QueryResult<TrustDetailsFormOptionsQuery, TrustDetailsFormOptionsQueryVariables>;